import { createSlice } from "@reduxjs/toolkit";

const managementSlice = createSlice({
  name: "managementSlice",
  initialState: {
    dayoffType: null,
    document: null,
    dayoffDocument: null,
    department: null,
    team: null,
    category: null,
    brand: null,
    model: null,
    equipment: null,
    usedEquipment: null,
  },
  reducers: {
    setDayoffType: (state, action) => {
      state.dayoffType = action.payload;
    },
    setDocument: (state, action) => {
      state.document = action.payload;
    },
    setDayoffDocument: (state, action) => {
      console.log("action :", action.payload);
      state.dayoffDocument = action.payload;
    },
    setDepartment: (state, action) => {
      state.department = action.payload;
    },
    setTeam: (state, action) => {
      state.team = action.payload;
    },
    setCategory: (state, action) => {
      state.category = action.payload;
    },
    setBrand: (state, action) => {
      state.brand = action.payload;
    },
    setModel: (state, action) => {
      state.model = action.payload;
    },
    setEquipment: (state, action) => {
      state.equipment = action.payload;
    },
    setUsedEquipment: (state, action) => {
      state.usedEquipment = action.payload;
    }
  },
});
export const {
  setDayoffType,
  setDocument,
  setDayoffDocument,
  setDepartment,
  setTeam,
  setCategory,
  setBrand,
  setModel,
  setEquipment,
  setUsedEquipment,
} = managementSlice.actions;
export const managementReducer = managementSlice.reducer;
